import { Toggle } from 'tailwindcss-stimulus-components'

export default class extends Toggle {
  static targets = ['toggleable']
  static values = {
    open: { type: Boolean, default: false }
  }

  declare toggleableTargets: HTMLElement[]
  declare openValue: boolean

  connect (): void {
    super.connect()

    this.applyInitialState()
  }

  private applyInitialState (): void {
    this.toggleableTargets.forEach(() => {
      if (this.openValue) {
        super.show()
      } else {
        super.hide()
      }
    })
  }
}
